/**
 * アプリ内共通定数
 *
 * 注意事項:
 * - コンポーネント(this/props)に依存しない定数のみを配置する
 * - 環境変数依存の設定は別ファイル(config/)で管理
 *
 * 今後の追加候補:
 * - CSV_DOWNLOAD: CSVダウンロード関連定数
 * - DATE_FORMAT: 日付フォーマット関連定数
 */

/**
 * 通話テキストダウンロード関連定数
 *
 * 使用箇所:
 * - AscUtils.buildCallTextDownloadFilename
 * - PhoneBook.downloadCallContents
 * - Record.downloadCallContents
 */
export const CALL_TEXT_DOWNLOAD = {
  /** デフォルトファイル名のベース（S3キー取得失敗時） */
  DEFAULT_BASENAME: 'call_text',
  /** ダウンロードファイルの拡張子 */
  FILE_EXTENSION: '.txt',
  /** BlobのMIMEタイプ */
  MIME_TYPE: 'text/plain;charset=utf-8',
};
